import Header from '../../components/feature/Header';
import { Link } from 'react-router-dom';

export default function AboutOperatorPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="pt-32 pb-20 px-8">
        <div className="max-w-4xl mx-auto">
          {/* Page Header */}
          <div className="mb-16">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-2 h-2 bg-[#1a2332] rotate-45"></div>
              <span className="text-sm font-medium text-[#1a2332] uppercase tracking-wider">About Operator</span>
            </div>
            <h1 className="text-5xl font-bold text-[#2d3748] mb-6">運営者情報</h1>
            <p className="text-lg text-[#4a5568]">
              Trim-Pageの運営者に関する情報をご案内いたします。
            </p>
          </div>

          {/* Operator Information */}
          <div className="space-y-8">
            {/* Service Name */}
            <div className="bg-white border border-[#e2e8f0] rounded-xl p-8">
              <h2 className="text-sm font-bold text-[#1a2332] uppercase tracking-wider mb-4">サービス名称</h2>
              <p className="text-lg text-[#2d3748] font-medium">Trim-Page（トリムページ）</p>
            </div>

            {/* Operator Name */}
            <div className="bg-white border border-[#e2e8f0] rounded-xl p-8">
              <h2 className="text-sm font-bold text-[#1a2332] uppercase tracking-wider mb-4">運営者</h2>
              <p className="text-lg text-[#2d3748] font-medium">個人事業主 山田太郎</p>
            </div>

            {/* Location */}
            <div className="bg-white border border-[#e2e8f0] rounded-xl p-8">
              <h2 className="text-sm font-bold text-[#1a2332] uppercase tracking-wider mb-4">所在地</h2>
              <p className="text-lg text-[#2d3748]">
                〒150-0001<br />
                東京都渋谷区神宮前1-1-1
              </p>
            </div>

            {/* Contact */}
            <div className="bg-white border border-[#e2e8f0] rounded-xl p-8">
              <h2 className="text-sm font-bold text-[#1a2332] uppercase tracking-wider mb-4">連絡先</h2>
              <div className="space-y-3">
                <div>
                  <p className="text-sm text-[#4a5568] mb-1">メールアドレス</p>
                  <a 
                    href="mailto:info@trim-page.com" 
                    className="text-lg text-[#2d3748] hover:text-[#4a5568] transition-colors"
                  >
                    info@trim-page.com
                  </a>
                </div>
                <div>
                  <p className="text-sm text-[#4a5568] mb-1">お問い合わせ</p>
                  <Link 
                    to="/#contact" 
                    className="text-lg text-[#2d3748] underline hover:text-[#4a5568] transition-colors"
                  >
                    お問い合わせフォーム
                  </Link>
                </div>
              </div>
            </div>

            {/* Business Description */}
            <div className="bg-white border border-[#e2e8f0] rounded-xl p-8">
              <h2 className="text-sm font-bold text-[#1a2332] uppercase tracking-wider mb-4">事業内容</h2>
              <div className="space-y-3 text-[#2d3748]">
                <p>静的ウェブサイトの制作・デザイン</p>
                <p>Cloudflare Pagesを活用したウェブサイト構築</p>
                <p>小規模店舗・個人事業主向けウェブサイト制作サービス</p>
                <p>ウェブサイト運用サポート・コンサルティング</p>
              </div>
            </div>

            {/* Establishment */}
            <div className="bg-white border border-[#e2e8f0] rounded-xl p-8">
              <h2 className="text-sm font-bold text-[#1a2332] uppercase tracking-wider mb-4">設立</h2>
              <p className="text-lg text-[#2d3748]">2024年4月</p>
            </div>

            {/* Business Hours */}
            <div className="bg-white border border-[#e2e8f0] rounded-xl p-8">
              <h2 className="text-sm font-bold text-[#1a2332] uppercase tracking-wider mb-4">営業時間</h2>
              <div className="space-y-2 text-[#2d3748]">
                <p>平日：10:00〜18:00</p>
                <p className="text-sm text-[#4a5568]">※土日祝日は休業日となります</p>
                <p className="text-sm text-[#4a5568]">※メールでのお問い合わせは24時間受付しております</p>
              </div>
            </div>
          </div>

          {/* Back to Home */}
          <div className="mt-16 text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-8 py-3 text-[#1a2332] font-medium underline hover:text-[#4a5568] transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              トップページへ戻る
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#1a2332] text-white py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            {/* Left Column */}
            <div className="md:col-span-1">
              <div className="flex items-center gap-3 mb-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/4944a4ba-c62a-4964-bf85-4ed6714cc305.png" 
                  alt="Trim-Page Logo" 
                  className="w-10 h-10 object-contain"
                />
                <h3 className="text-3xl font-bold">Trim-Page</h3>
              </div>
              <p className="text-white/80 leading-relaxed mb-6">
                小規模店舗・個人事業主のための、月額費用のない静的サイト制作サービス
              </p>
              <div className="flex gap-4">
                {['ri-twitter-x-line', 'ri-facebook-circle-line', 'ri-instagram-line', 'ri-linkedin-box-line'].map((icon, index) => (
                  <a
                    key={index}
                    href="#"
                    className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white/10 transition-colors cursor-pointer"
                  >
                    <i className={`${icon} text-lg`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Middle Column */}
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider mb-6">Contact</h4>
              <div className="space-y-4">
                <div>
                  <p className="text-sm text-white/60 mb-1">メールアドレス</p>
                  <a href="mailto:info@trim-page.com" className="text-white hover:text-white/80 transition-colors">
                    info@trim-page.com
                  </a>
                </div>
                <div>
                  <Link
                    to="/#contact"
                    className="text-white underline hover:text-white/80 transition-colors cursor-pointer"
                  >
                    お問い合わせフォーム
                  </Link>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider mb-6">Information</h4>
              <div className="space-y-4">
                <Link to="/about-operator" className="block text-white hover:text-white/80 transition-colors">
                  運営者情報
                </Link>
                <Link to="/tokushoho" className="block text-white hover:text-white/80 transition-colors">
                  特定商取引法に基づく表記
                </Link>
                <Link to="/privacy-policy" className="block text-white hover:text-white/80 transition-colors">
                  プライバシーポリシー
                </Link>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/60">© 2025 Trim-Page. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors">
                利用規約
              </a>
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors">
                サイトマップ
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-sm text-white/60 hover:text-white transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
